import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AudioLines } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
    }
  }, [loading, user, navigate, location]);

  if (loading || !user) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#0A0A0A] border border-white/10 flex items-center justify-center">
            <AudioLines className="w-5 h-5 text-[#FF2D55] animate-pulse" strokeWidth={2.2} />
          </div>
          <div className="text-xs text-zinc-500 font-mono uppercase tracking-[0.2em]">loading…</div>
        </div>
      </div>
    );
  }

  return children;
}
